import * as Gsap from "gsap";
import * as HLF from "html-living-framework";
import { TimelineLite } from "gsap";

export class Button extends HLF.Button {
    protected static readonly SCALE_NORMAL: number = 1.0;
    protected static readonly SCALE_OVER: number = 1.05;
    protected static readonly SCALE_DOWN: number = 0.95;

    protected _hoverVO: string | undefined;
    protected _clickedSFX: string | undefined;
    protected readonly _timeline: TimelineLite = new TimelineLite();

    constructor(
        pCallback: () => void,
        pAsset: string,
        pSheet?: string | string[],
        pHoverVO?: string,
        pClickedSFX?: string,
    ) {
        super(pCallback, pAsset, pSheet);

        this._hoverVO = pHoverVO;
        this._clickedSFX = pClickedSFX;
    }

    public get sprite() {return this._image;}

    public onFocusBegin(): void {
        super.onFocusBegin();
        this.playHoverVO();
    }

    public onFocusActivated(): void {
        if (this.interactive) {
            this.playClickedSFX();
        }
        super.onFocusActivated();
    }

    public getOnboardingPosition(): PIXI.Point {
        return this.getGlobalPosition();
    }

    public getOnboardingRotation(): number {
        return 0;
    }

    public show(pAnimate: boolean = true, pCallback?: () => void): void {
        if (pAnimate) {
            this.visible = true;
            this.alpha = 0;
            this._timeline.clear();
            this.scale.set(1, 1);
            this._timeline.to(this, 0.25, {
                alpha: 1,
            });
            this._timeline.call(()=>{
                PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this);
            });
            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.visible = true;
            this.alpha = 1;
            PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this);
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }

    public hide(pAnimate: boolean = true, pCallback?: () => void): void {
        PubSub.publishSync(HLF.UNREGISTER_FOCUSABLE, this);

        if (pAnimate) {
            this._timeline.clear();
            this._timeline.to(this, 0.5, {
                pixi: {
                    alpha: 0,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 1.1,
                    scaleY: 1.1,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 0.3,
                    scaleY: 0.3,
                },
            }, 0.25);

            this._timeline.call(()=>{
                this.visible = false;
            });
            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.alpha = 0;
            this.visible = false;
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }

    protected onPointerOver(pEvent: PIXI.InteractionEvent): void {
        super.onPointerOver(pEvent);
        Gsap.TweenMax.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_OVER,
            y: Button.SCALE_OVER,
            ease: Gsap.Sine.easeInOut,
        });
        this.playHoverVO();
    }

    protected onPointerDown(pEvent: PIXI.InteractionEvent): void {
        super.onPointerDown(pEvent);
        Gsap.TweenMax.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_DOWN,
            y: Button.SCALE_DOWN,
            ease: Gsap.Sine.easeInOut,
        });
    }

    protected onPointerUp(pEvent: PIXI.InteractionEvent): void {
        if (this._eventData !== undefined) {
            Gsap.TweenMax.to(this._visuals.scale, 0.15, {
                x: Button.SCALE_OVER,
                y: Button.SCALE_OVER,
                ease: Gsap.Sine.easeInOut,
            });
            this.playClickedSFX();
        }
        super.onPointerUp(pEvent);
    }

    protected onPointerOut(pEvent: PIXI.InteractionEvent): void {
        super.onPointerOut(pEvent);
        Gsap.TweenMax.to(this._visuals.scale, 0.15, {
            x: Button.SCALE_NORMAL,
            y: Button.SCALE_NORMAL,
            ease: Gsap.Sine.easeInOut,
        });
    }

    protected playHoverVO(): void {
        if (this._hoverVO !== undefined) {
            HLF.Application.instance.voiceover.playVO(this._hoverVO, {priority: -1, mode: HLF.PlayMode.Override});
        }
    }

    protected playClickedSFX(): void {
        if (this._clickedSFX !== undefined) {
            PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(this._clickedSFX, 1, false, HLF.AudioCategory.SFX));
        }
    }
}
